export enum RateType {
  Duration = 'durationRate',
  Flat = 'flatRate',
  FlatTransactAtEntry = 'flatTransactAtEntryRate',
  Tabular = 'tabularRate',
}
